document.addEventListener("DOMContentLoaded", (event) => {
  function defaultCartBraceletFunctionality () { 
    // Select all delete buttons by class
    const deleteButtons = document.querySelectorAll('.custom-button[data-index]');
    
    deleteButtons.forEach(deleteBtn => {
      deleteBtn.addEventListener("click", (e) => {
        console.log("deleteBtn clicked");
        e.preventDefault();
        
        // Get the index from the clicked button's data attribute
        const itemIndex = e.currentTarget.getAttribute('data-index');
        console.log("itemIndex", itemIndex);
        
        if (!itemIndex) {
          console.error("No item index found");
          return;
        } 
        
        var localStorageItem = itemIndex && `charmBraceletData_${itemIndex}`;
        
        if (!localStorageItem) return;
        
        // Show loading state
        const originalHTML = e.currentTarget.innerHTML;
        e.currentTarget.disabled = true;
        e.currentTarget.innerHTML = `
        <span class="svg-wrapper">
          <svg class="spinner" viewBox="0 0 50 50">
            <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
          </svg>
        </span>
        `;
        
        // First get current cart
        fetch("/cart.js")
        .then(response => {
          if (!response.ok) throw new Error("Failed to fetch cart");
          return response.json();
          })
          .then(cart => {
            // Find all items that match either main_product or main_product_id
            const itemsToRemove = cart.items.filter(item => {
              if (item.properties) {
                return (
                  item.properties.main_product === itemIndex || 
                  item.properties.main_product_id === itemIndex
                );
              }
              return false;
            });
            
            console.log("itemsToRemove", itemsToRemove);
            if (itemsToRemove.length === 0) {
              console.log("No matching items found");
              location.reload();
              return;
            }

            // Create Shopify update format
            const updates = {};
            itemsToRemove.forEach(item => {
              updates[item.key] = 0; // Set quantity to 0 to remove
            });

            // Remove the items
            return fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates })
            });
          })
          .then(response => {
            if (!response.ok) throw new Error("Failed to update cart");
            localStorage.removeItem(localStorageItem);
            location.reload();
            console.log("Delete Process InProgress");
          })
          .catch(error => {
            console.error("Error:", error);
            // Show error message near the button
            const errorMsg = document.createElement('div');
            errorMsg.className = 'delete-error-message';
            errorMsg.textContent = 'Failed to remove items. Please try again.';
            e.currentTarget.parentNode.appendChild(errorMsg);
            setTimeout(() => errorMsg.remove(), 3000);
          })
          .finally(() => {
            // Reset button state
            console.log("Delete Process Completed");
            e.currentTarget.disabled = false;
            e.currentTarget.innerHTML = originalHTML;
          });
      });
    });
  }


  // Check when Cart Update
  document.addEventListener('cart:updated', (event) => {
    defaultCartBraceletFunctionality();
  });
  
  // Check manually when Cart Update
  (function() {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      if (args[0].includes('/cart') && response.ok) {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      return response;
    };
  })();


  // Initial check
  defaultCartBraceletFunctionality();
});